import { render, staticRenderFns } from "./WorkoutHistory.vue?vue&type=template&id=4b7a7a88&scoped=true"
import script from "./WorkoutHistory.vue?vue&type=script&lang=js"
export * from "./WorkoutHistory.vue?vue&type=script&lang=js"
import style0 from "./WorkoutHistory.vue?vue&type=style&index=0&id=4b7a7a88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7a7a88",
  null
  
)

export default component.exports